import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const pathLabels = {
  '': 'Home',
  matches: 'Matches',
  teams: 'Teams',
  stadiums: 'Stadiums',
  cities: 'Cities',
  'travel-planner': 'Travel Planner',
  'itinerary-planner': 'AI Itinerary',
  'fan-meetups': 'Fan Meetups',
  cockpit: 'Cockpit',
  standings: 'Standings',
  news: 'News',
  tickets: 'Tickets',
  hotels: 'Hotels',
  tours: 'Tours',
  guides: 'Guides',
  'privacy-policy': 'Privacy Policy',
  about: 'About',
  contact: 'Contact',
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (pathnames.length === 0) return null;
  if (location.pathname === '/guides') return null;

  return (
    <nav className="px-4 py-2.5 bg-surface-container-low/80 dark:bg-slate-900/60 border-b border-outline-variant/15 dark:border-slate-800" aria-label="Breadcrumb">
      <ol className="flex items-center text-sm text-on-surface-variant dark:text-slate-400 max-w-7xl mx-auto overflow-x-auto nav-no-scrollbar font-body">
        <li>
          <Link to="/" className="hover:text-primary dark:hover:text-primary-container">
            Home
          </Link>
        </li>
        {pathnames.map((name, i) => {
          const path = `/${pathnames.slice(0, i + 1).join('/')}`;
          const label = pathLabels[name] || name.replace(/-/g, ' ');
          const isLast = i === pathnames.length - 1;
          return (
            <li key={path} className="flex items-center">
              <ChevronRight className="h-4 w-4 mx-1 text-outline dark:text-slate-600" aria-hidden />
              {isLast ? (
                <span className="text-on-surface dark:text-slate-100 font-medium">{label}</span>
              ) : (
                <Link to={path} className="hover:text-primary dark:hover:text-primary-container">
                  {label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
